module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.ba95810b.ttf";